import { useEffect } from 'react';

const useTiltEffect = (ref, condition = true, options = {}) => {
	const {
		multiplierX = 4,
		multiplierY = 4,
		perspective = 500,
	} = options;

	useEffect(() => {
		const node = ref?.current;
		if (!node || !condition) return;

		const handleMouseMove = (e) => {
			const rect = node.getBoundingClientRect();
			const x = (e.clientX - rect.left) / rect.width;
			const y = (e.clientY - rect.top) / rect.height;

			const tiltX = (y - 0.5) * -multiplierX;
			const tiltY = (x - 0.5) * multiplierY;

			node.style.transform = `perspective(${perspective}px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;
		};

		const resetTilt = () => {
			node.style.transform = `perspective(${perspective}px) rotateX(0deg) rotateY(0deg)`;
		};

		node.addEventListener('mousemove', handleMouseMove, { passive: true });
		node.addEventListener('mouseleave', resetTilt, { passive: true });

		return () => {
			node.removeEventListener('mousemove', handleMouseMove);
			node.removeEventListener('mouseleave', resetTilt);
		};
	}, [ref, condition, multiplierX, multiplierY, perspective]);
};

export default useTiltEffect;
